import axios from 'axios'

// Ensure the API URL is properly formatted as an absolute URL
const getApiBaseUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL

  // If no API URL is provided, use localhost for development
  if (!apiUrl) {
    return 'http://localhost:4000/v1'
  }

  // If the URL doesn't start with http/https, it might be treated as relative
  // Ensure it's treated as absolute
  if (!apiUrl.startsWith('http://') && !apiUrl.startsWith('https://')) {
    // For production, assume https
    return `https://${apiUrl}`
  }

  return apiUrl
}

// Create a new client
const client = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor to add authentication token
client.interceptors.request.use(
  config => {
    // Get token from localStorage or sessionStorage
    const token =
      localStorage.getItem('dealer_token') ||
      sessionStorage.getItem('dealer_token')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle token expiration
client.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // Handle 401 Unauthorized responses
    if (error.response && error.response.status === 401) {
      // Token has expired or is invalid
      console.log('Authentication token expired or invalid')

      // Clear authentication data
      // localStorage.removeItem('dealer_token')
      // localStorage.removeItem('dealer_info')
      // sessionStorage.removeItem('dealer_token')
      // sessionStorage.removeItem('dealer_info')

      // Redirect to login page
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }

    return Promise.reject(error)
  }
)

export { client }
